module.exports = __webpack_public_path__ + "static/media/Jai Jemmi.12082bfa.JPG";